import { Dispatch } from 'redux';
import { JitsiEndpointMessage } from '../../../../interfaces';

export const handleMirroringEndpointMessage = (
  message: JitsiEndpointMessage,
  dispatch: Dispatch
) => {
  dispatch(message.attributes);
};
